import { render, staticRenderFns } from "./AvaliarIrregularidadeForm.vue?vue&type=template&id=dfed9e12&"
import script from "./AvaliarIrregularidadeForm.vue?vue&type=script&lang=js&"
export * from "./AvaliarIrregularidadeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports